import { Subject } from 'rxjs';

export class CrateUpdateService {
  private static instance: CrateUpdateService;
  private crateUpdateSubject = new Subject<string>();

  public static getInstance(): CrateUpdateService {
    if (!CrateUpdateService.instance) {
      CrateUpdateService.instance = new CrateUpdateService();
    }
    return CrateUpdateService.instance;
  }

  public getUpdates() {
    return this.crateUpdateSubject.asObservable();
  }

  public notifyCrateUpdated(crateId: string) {
    this.crateUpdateSubject.next(crateId);
  }
}

export default CrateUpdateService.getInstance();
